import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom-v5-compat'

import Loader from '@/app/component/atom/loader'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_EXPORT_SMS_REPORT, EXPORT_SMS_REPORT_PENDING } from '@/app/module/reports/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { useRequirePermission } from '@/app/module/user/store/ts/hooks'
import { selectUserLoading } from '@/app/module/user/store/ts/selectors'
import { esApi } from '@/app/store/api'

import NoReportPermission from './no-report-permission'
import SmsReport from './sms-report'
import SmsReportListContainer from './sms-report-list.container'

type Props = {
  isCreateMode?: boolean
}

const SMSReportContainer: React.FC<Props> = ({ isCreateMode = false }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const orgId = useSelector(selectOrgId)
  const hasPermission = useRequirePermission('downloadReport')
  const userLoading = useSelector(selectUserLoading)

  const [createReport, { isLoading }] = esApi.endpoints.createOrgReport.useMutation()
  const handleCreate = async (month: string) => {
    try {
      await createReport({ orgId: String(orgId), body: { function: 'smsreport', month } }).unwrap()
      dispatch(
        createNotification({
          'export-sms-report-pending': {
            type: 'success',
            message: EXPORT_SMS_REPORT_PENDING,
          },
        }),
      )
      navigate('/reports/smsreport')
      return true
    } catch {
      dispatch(
        createNotification({
          'export-sms-report-error': {
            type: 'error',
            message: ERROR_EXPORT_SMS_REPORT,
          },
        }),
      )
      return false
    }
  }

  const handleWizardOpen = React.useCallback(() => {
    navigate('/reports/smsreport/create')
  }, [navigate])

  const handleCancel = React.useCallback(() => {
    navigate('/reports/smsreport')
  }, [navigate])

  return (
    <>
      {!userLoading && !hasPermission && <NoReportPermission />}
      {hasPermission && isCreateMode && (
        <SmsReport isLoading={isLoading} onCreate={handleCreate} onCancel={handleCancel} />
      )}
      {hasPermission && !isCreateMode && <SmsReportListContainer onCreateClick={handleWizardOpen} />}
      {isLoading && <Loader />}
    </>
  )
}

export default SMSReportContainer
